/* ============================================================
   NOMAD — theme behaviour
   Cart state lives on Shopify (Cart AJAX API); the drawer is
   re-rendered through the Section Rendering API rather than
   being rebuilt in JavaScript, so Liquid stays the source of truth.
   ============================================================ */
(() => {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const R = window.NOMAD?.routes || {};

  /* ---------- money ---------- */
  const money = (cents) => {
    const fmt = window.NOMAD?.moneyFormat || '{{amount}} €';
    const n = cents / 100;
    const fr = (dec, thou) =>
      n.toFixed(2).replace('.', dec).replace(/\B(?=(\d{3})+(?!\d))/g, thou).replace(dec + '00', dec + '00');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, n.toLocaleString('fr-FR', { minimumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toLocaleString('fr-FR'))
      .replace(/<[^>]*>/g, '');
  };

  /* ---------- 1. Header ---------- */
  const header = $('.header');
  if (header) {
    const hasHero = !!$('.hero');
    let last = 0;
    const onScroll = () => {
      const y = scrollY;
      const trigger = hasHero ? innerHeight * 0.86 : 20;
      header.classList.toggle('is-solid', y > trigger);
      header.classList.toggle('is-hidden', y > last && y > 320 && !$('.drawer.is-open'));
      last = y;
    };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 2. Header wordmark: letters flip every 3s ---------- */
  $$('.brand').forEach((el) => {
    const txt = el.textContent.trim();
    el.setAttribute('aria-label', txt);
    el.textContent = '';
    [...txt].forEach((c, i) => {
      const s = document.createElement('span');
      s.className = 'bch';
      s.setAttribute('aria-hidden', 'true');
      s.style.setProperty('--i', i);
      s.textContent = c;
      el.appendChild(s);
    });
  });

  /* ---------- 3. Split headings (used when the logotype is off) ---------- */
  $$('[data-split]').forEach((el) => {
    const txt = el.textContent.trim();
    el.textContent = '';
    [...txt].forEach((c, i) => {
      const mask = document.createElement('span');
      mask.className = 'chm';
      const s = document.createElement('span');
      s.className = 'ch';
      s.textContent = c;
      s.style.animationDelay = `${0.25 + i * 0.075}s`;
      mask.appendChild(s);
      el.appendChild(mask);
    });
  });

  /* ---------- 4. Scroll reveals ---------- */
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  const observeReveals = (root = document) =>
    $$('[data-reveal]', root).forEach((el, i) => {
      if (el.style.getPropertyValue('--i') === '') el.style.setProperty('--i', i % 8);
      io.observe(el);
    });
  observeReveals();

  /* ---------- 5. Parallax ---------- */
  const par = $$('[data-parallax]');
  if (par.length && !reduced) {
    let tick = false;
    const run = () => {
      par.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        el.style.transform = `translate3d(0, ${(-p * 7).toFixed(2)}%, 0)`;
      });
      tick = false;
    };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- 6. Drag rails (mouse only; touch scrolls natively) ---------- */
  const bindRails = (root = document) => $$('[data-rail]', root).forEach((rail) => {
    if (rail.dataset.bound) return;
    rail.dataset.bound = '1';
    let down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', (e) => {
      if (!down) return;
      const d = e.clientX - sx;
      moved = Math.abs(d);
      if (moved > 6) rail.classList.add('is-drag');
      rail.scrollLeft = sl - d;
    });
    const up = () => { down = false; setTimeout(() => rail.classList.remove('is-drag'), 40); };
    rail.addEventListener('pointerup', up);
    rail.addEventListener('pointercancel', up);
    rail.addEventListener('click', (e) => { if (moved > 6) e.preventDefault(); }, true);
  });
  bindRails();

  /* ---------- 7. Custom cursor ---------- */
  if (matchMedia('(pointer:fine)').matches && !reduced) {
    const ring = Object.assign(document.createElement('div'), { className: 'cursor' });
    const dot  = Object.assign(document.createElement('div'), { className: 'cursor-dot' });
    document.body.append(ring, dot);
    let mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
    addEventListener('pointermove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = `translate(${mx}px, ${my}px)`;
    }, { passive: true });
    (function loop() {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      ring.style.transform = `translate(${rx}px, ${ry}px)`;
      requestAnimationFrame(loop);
    })();
    document.addEventListener('pointerover', (e) =>
      ring.classList.toggle('is-big', !!e.target.closest('a, button, .card, input, select, [data-rail]')));
    addEventListener('pointerleave', () => document.body.classList.add('no-cursor'));
    addEventListener('pointerenter', () => document.body.classList.remove('no-cursor'));
  }

  /* ---------- 8. Menu ---------- */
  const menu = $('[data-menu]');
  const openMenu = (on) => {
    menu?.classList.toggle('is-open', on);
    document.body.classList.toggle('no-scroll', on);
    $$('.menu__nav a').forEach((a, i) => { a.style.animationDelay = `${0.12 + i * 0.06}s`; });
  };
  $('[data-menu-open]')?.addEventListener('click', () => openMenu(true));
  $('[data-menu-close]')?.addEventListener('click', () => openMenu(false));
  $$('.menu__nav a').forEach((a) => a.addEventListener('click', () => openMenu(false)));

  /* ---------- 9. Toast ---------- */
  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = Object.assign(document.createElement('div'), { className: 'toast' }); document.body.append(t); }
    t.textContent = msg;
    requestAnimationFrame(() => t.classList.add('is-on'));
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-on'), 2400);
  };

  /* ---------- 10. Cart ---------- */
  const drawerWrap = $('#CartDrawerWrap');
  const openCart = (on) => {
    $('[data-drawer]')?.classList.toggle('is-open', on);
    $('[data-overlay]')?.classList.toggle('is-open', on);
    document.body.classList.toggle('no-scroll', on);
  };

  async function refreshCart({ open = false } = {}) {
    const res = await fetch(`${location.pathname}?sections=cart-drawer`);
    const data = await res.json();
    if (drawerWrap && data['cart-drawer']) {
      const wasOpen = $('[data-drawer]')?.classList.contains('is-open');
      drawerWrap.innerHTML = data['cart-drawer'];
      if (wasOpen || open) openCart(true);
    }
    const badge = $('[data-cart-count]');
    const val = $('[data-cart-count-value]');
    if (badge && val) {
      badge.textContent = val.textContent.trim();
      badge.classList.add('is-bump');
      setTimeout(() => badge.classList.remove('is-bump'), 320);
    }
  }

  async function cartAdd(id, quantity = 1) {
    const res = await fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || 'Ajout impossible');
      return false;
    }
    await refreshCart({ open: true });
    return true;
  }

  async function cartChange(key, quantity) {
    await fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refreshCart();
    if (document.body.classList.contains('template-cart')) location.reload();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(true); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-overlay]')) { openCart(false); return; }
    const q = e.target.closest('[data-qty]');
    if (q) { e.preventDefault(); cartChange(q.dataset.key, Number(q.dataset.qty)); }
  });

  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    openCart(false); openMenu(false); showModal(false);
  });

  /* quick-add straight from a product card */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.card__quick');
    const label = btn.textContent;
    btn.disabled = true;
    const ok = await cartAdd(form.querySelector('[name="id"]').value);
    btn.disabled = false;
    if (ok) {
      btn.classList.add('is-done');
      btn.textContent = 'Ajouté ✓';
      setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; }, 1400);
    }
  });

  /* ---------- 11. Product page: variants ---------- */
  const root = $('[data-product-root]');
  const variantsTag = $('[data-variants]');
  if (root && variantsTag) {
    const variants = JSON.parse(variantsTag.textContent);
    const idInput  = $('[data-variant-id]', root);
    /* la barre d'achat mobile duplique bouton, libelle et prix : on met a jour
       toutes les occurrences, pas seulement la premiere */
    const addBtns   = $$('[data-add-btn]', root);
    const addLabels = $$('[data-add-label]', root);
    const priceNows = $$('[data-price-current]', root);
    const priceOld = $('[data-price-compare]', root);

    /* An option with a single value is not rendered at all (see main-product),
       so a group's position in the DOM is not its position in variant.options.
       We read the real index off data-option-index; options that were skipped
       stay null and filter nothing, which is right: they have one value, every
       variant shares it. Using the DOM position instead hid every button as
       soon as a single-value option came first. */
    const optIndex = (grp) => parseInt(grp.dataset.optionIndex, 10);

    const selected = () => {
      const chosen = [];
      $$('[data-option-index]', root).forEach((grp) => {
        const on = $('.opt.is-on', grp);
        chosen[optIndex(grp)] = on ? on.dataset.optionValue : null;
      });
      for (let k = 0; k < chosen.length; k++) {
        if (chosen[k] === undefined) chosen[k] = null;
      }
      return chosen;
    };

    /* Cascade: option 1 stays fully open, each following option is filtered by
       what is chosen before it. A combination that does not exist is hidden;
       one that exists but is out of stock is shown struck through. */
    function refreshOptions() {
      const groups = $$('[data-option-index]', root);
      const chosen = selected();

      groups.forEach((grp) => {
        const i = optIndex(grp);
        $$('.opt', grp).forEach((btn) => {
          const val = btn.dataset.optionValue;
          const matches = variants.filter((v) =>
            v.options[i] === val &&
            chosen.slice(0, i).every((c, j) => c === null || v.options[j] === c));
          const exists  = matches.length > 0;
          const inStock = matches.some((v) => v.available);
          btn.hidden   = !exists;
          btn.disabled = exists && !inStock;
        });

        // the chosen value may have just disappeared: fall back to the first one left
        const on = $('.opt.is-on', grp);
        if (!on || on.hidden || on.disabled) {
          const list = $$('.opt', grp);
          const next = list.find((b) => !b.hidden && !b.disabled)
                    || list.find((b) => !b.hidden);
          if (next) {
            list.forEach((b) => b.classList.toggle('is-on', b === next));
            chosen[i] = next.dataset.optionValue;
          }
        }
      });
    }

    function sync() {
      refreshOptions();
      const chosen = selected();
      const v = variants.find((va) =>
        chosen.every((val, i) => val === null || va.options[i] === val));
      if (!v) {
        addBtns.forEach((b) => { b.disabled = true; });
        addLabels.forEach((l) => { l.textContent = window.NOMAD?.strings?.unavailable || 'Indisponible'; });
        return;
      }

      idInput.value = v.id;
      priceNows.forEach((el) => { el.textContent = money(v.price); });
      if (priceOld) {
        priceOld.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        priceOld.hidden = !(v.compare_at_price > v.price);
      }
      addBtns.forEach((b) => { b.disabled = !v.available; });
      const lbl = v.available
        ? (window.NOMAD?.strings?.added ? 'Ajouter au panier' : 'Ajouter au panier')
        : (window.NOMAD?.strings?.soldOut || 'Épuisé');
      addLabels.forEach((l) => { l.textContent = lbl; });

      $$('[data-option-index]', root).forEach((grp) => {
        const lab = $('[data-option-label]', grp);
        const on = $('.opt.is-on', grp);
        if (lab && on) lab.textContent = on.dataset.optionValue;
      });

      const url = new URL(location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    root.addEventListener('click', (e) => {
      const b = e.target.closest('.opt');
      if (!b || b.disabled) return;
      $$('.opt', b.closest('.opts')).forEach((o) => o.classList.toggle('is-on', o === b));
      sync();
    });

    sync();

    $('#ProductForm')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtns.forEach((b) => { b.disabled = true; });
      await cartAdd(idInput.value);
      addBtns.forEach((b) => { b.disabled = false; });
    });
  }

  /* ---------- 12. Accordions ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.acc__btn');
    if (!btn) return;
    const item = btn.parentElement;
    const panel = $('.acc__panel', item);
    const open = item.classList.toggle('is-open');
    panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ---------- 13. Addresses ---------- */
  $('[data-addr-new]')?.addEventListener('click', () => {
    const box = $('#AddressNew');
    if (box) box.hidden = !box.hidden;
  });

  /* ---------- 14. Page transitions ---------- */
  let veil = $('.veil');
  if (!veil) {
    veil = Object.assign(document.createElement('div'), { className: 'veil' });
    document.body.append(veil);
  }
  if (!reduced) {
    /* Retour arriere : le navigateur restaure la page depuis son cache sans
       rejouer le script, et le voile reste fige en position couvrante (le
       `forwards` de is-out). On le renvoie explicitement en bas. */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      veil.classList.remove('is-out', 'is-in');
      void veil.offsetWidth;            // force le rejeu de l'animation
      veil.classList.add('is-in');
      veil.addEventListener('animationend', () => veil.classList.remove('is-in'), { once: true });
    });

    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || a.closest('[data-drawer]')) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || a.target === '_blank' || url.href === location.href) return;
      if (url.pathname === location.pathname && url.hash) return;
      e.preventDefault();
      veil.classList.add('is-out');
      /* On part a la fin de l'animation, pas sur un delai fixe : le voile
         etait coupe en pleine course quand les deux ne coincidaient pas.
         Le timeout ne sert plus que de filet si animationend ne vient pas. */
      let left = false;
      const go = () => { if (!left) { left = true; location.href = url.href; } };
      veil.addEventListener('animationend', go, { once: true });
      setTimeout(go, 600);   // filet, au-dela de la duree d'animation
    });
  }

  /* ---------- 15. Cookie consent -> Shopify Customer Privacy API ---------- */
  const banner = $('[data-cookie]');
  const modal  = $('[data-cookie-modal]');
  const CKEY   = 'nomad.consent.seen';
  let draft = { analytics: false, marketing: false };

  const seen     = () => { try { return localStorage.getItem(CKEY) === '1'; } catch { return false; } };
  const markSeen = () => { try { localStorage.setItem(CKEY, '1'); } catch {} };

  /* The privacy API loads asynchronously. Waiting for it — instead of guessing
     after a fixed delay — is what stops the banner reappearing on every page. */
  function withPrivacy(cb) {
    if (window.Shopify?.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return cb(null);
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (err) => cb(err ? null : window.Shopify.customerPrivacy || null)
    );
  }

  function showModal(on) {
    modal?.classList.toggle('is-on', on);
    if (on) $$('[data-ck-toggle]', modal).forEach((b) =>
      b.setAttribute('aria-checked', String(!!draft[b.dataset.ckToggle])));
  }

  function applyConsent(c) {
    markSeen();
    banner?.classList.remove('is-on');
    showModal(false);
    withPrivacy((cp) => cp?.setTrackingConsent(
      { analytics: c.analytics, marketing: c.marketing, preferences: c.analytics }, () => {}));
  }

  if (banner) {
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-ck-toggle]');
      if (t) { draft[t.dataset.ckToggle] = !draft[t.dataset.ckToggle]; showModal(true); return; }

      const b = e.target.closest('[data-ck]');
      if (b) {
        const a = b.dataset.ck;
        if (a === 'custom') { banner.classList.remove('is-on'); showModal(true); }
        if (a === 'allow')  applyConsent({ analytics: true,  marketing: true });
        if (a === 'deny')   applyConsent({ analytics: false, marketing: false });
        if (a === 'save')   applyConsent(draft);
        return;
      }
      if (e.target.closest('[data-cookie-open]')) { e.preventDefault(); showModal(true); }
      if (e.target === modal) showModal(false);
    });

    if (!seen()) {
      withPrivacy((cp) => {
        const ask = cp ? cp.shouldShowBanner() : true;
        if (ask) banner.classList.add('is-on');
        else markSeen();
      });
    }
  }

  /* re-bind things inside sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', (e) => {
    observeReveals(e.target);
    bindRails(e.target);
  });
})();
